export function macValidator(_, value) {
  const macRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;
  if (!macRegex.test(value)) {
    return Promise.reject(
      new Error("Please enter a valid MAC address")
    );
  }
  return Promise.resolve();
}
